/**
 * branding.js — ponto ÚNICO da identidade da solução (nome + logo).
 *
 * Para rebrandizar a solução (trocar NOME e/ou LOGO), altere SOMENTE este
 * arquivo — os consumidores (NavaWordmark, título da aba, meta) leem daqui:
 *   - PRODUCT_NAME    → aba do navegador (document.title) e texto alt do logo
 *   - PRODUCT_TAGLINE → descrição/meta
 *   - productLogo     → imagem do lockup exibida pelo NavaWordmark
 *
 * Marca mantida ESTÁTICA nesta fase. Uma futura versão editável por-tenant
 * (plano "#4 configurável") viria da API e substituiria estes defaults sem
 * mudar os consumidores.
 */
// Logo "nava Sphere" — variante CLARA (texto creme) para os fundos escuros do
// splash/login/MFA/sidebar. A versão escura fica em nava-sphere-dark.svg (fundos claros).
import productLogo from '@/assets/nava-sphere-light.svg';

export const PRODUCT_NAME = 'Nava Sphere';

export const PRODUCT_TAGLINE =
  'Plataforma de Engenharia de Software com Orquestração de Agentes de IA';

/**
 * Identificação da instância no cartão "Tenant" da Sidebar. A implantação é
 * single-tenant e a API não expõe nome de tenant — é configuração de implantação,
 * não dado operacional (era o MOCK_TENANT da Sidebar).
 */
export const INSTANCE_TENANT = Object.freeze({ name: 'Nava', tier: 'Single-tenant cloud · BR' });

export const BRANDING = Object.freeze({
  name: PRODUCT_NAME,
  tagline: PRODUCT_TAGLINE,
  logo: productLogo,
  logoAlt: PRODUCT_NAME,
});
